'use client';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 50px 30px;

  background-color: ${theme.colors.neutral[300]};

  ${legacyTheme.breakpoints.up('md')} {
    gap: 0px;
    padding: 50px 120px;
  }
`;

export const LegalReviews = () => (
  <Wrapper data-testid="reviews-legal-block">
    <Typography align="left" color="grey" italic variant="p2">
      *Prose counts 5-star reviews on a per product basis, including those from first-time customers
      and repeat customers who have provided feedback through our Review & Refine® survey. When a
      customer is repeatedly satisfied, and submits another 5-star review, Prose counts that review
      as well. Our goal is to deliver always-improving results that our customers love, long-term.
    </Typography>
  </Wrapper>
);
